<template>
  <a-form ref='ruleForm' :rules="rules" :model='form' :labelCol="{span:5}" :wrapper-col="{span:19}">
    <a-form-item label="选择周期" name='time_type' required>
      <a-radio-group v-model:value="form.time_type">
        <a-radio :value="1">天</a-radio>
        <a-radio :value="2">周</a-radio>
        <a-radio :value="3">自定义</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="选择星期" name='week_arr' v-if="form.time_type==2">
      <a-checkbox-group v-model:value="form.week_arr">
        <a-checkbox value="1">周一</a-checkbox>
        <a-checkbox value="2">周二</a-checkbox>
        <a-checkbox value="3">周三</a-checkbox>
        <a-checkbox value="4">周四</a-checkbox>
        <a-checkbox value="5">周五</a-checkbox>
        <a-checkbox value="6">周六</a-checkbox>
        <a-checkbox value="7">周日</a-checkbox>
      </a-checkbox-group>
    </a-form-item>
    <a-form-item label="选择日期" name='date_arr' v-if="form.time_type==3">
      <p v-for="(v,index) in form.date_arr" :key="v">
        <a-range-picker v-model:value="v.time" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" />
        <MinusCircleOutlined @click="delDate(index)" class="m-l-5" />
      </p>
      <a-button @click="addDate">添加</a-button>
    </a-form-item>
    <a-form-item label="选择时间段" name='time_arr'>
      <p v-for="(v,index) in form.time_arr" :key="v">
        <a-time-picker v-model:value="v.start" placeholder="开始时间" valueFormat="HH:mm:ss" /> -
        <a-time-picker valueFormat="HH:mm:ss"  @change="(e)=>changeDate(e,index,'end')" placeholder="结束时间"  :disabledHours="(e)=>disabledHours(e,v)" 
           :disabledMinutes="(e)=>getDisabledMinutes(e,v)"
           :defaultValue="moment(v.start||'', 'HH:mm:ss')"
            :disabledSeconds="(e1,e2)=>getDisabledSeconds(e1,e2,v)"
          v-if="v.start" v-model:value="v.end" />
        <MinusCircleOutlined @click="delTime(index)" v-if='index !== 0' class="m-l-5" />
      </p>
      <a-button  @click="addTime">添加</a-button>
    </a-form-item>
    <a-form-item :wrapper-col="{offset:4}">
      <a-button @click="submit">确定</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { onMounted, ref } from "vue";
import { iscode } from "@/utils/app";
import { MinusCircleOutlined } from "@ant-design/icons-vue";
import { getMemberTagList, getMemberVip } from "@/api/member";
import { message } from "ant-design-vue";
const moment = require("moment");
const rules = {
  time_type: [{ type: "number", required: true, message: "请选中客户标签" }],
  week_arr: [{ type: "array", required: true, message: "请选择星期" }],
  time_arr: [{ type: "array", required: true, message: "请选择日期" }],
  date_arr: [{ type: "array", required: true, message: "请选择时间" }],
};
export default {
  components: { MinusCircleOutlined },
  setup(props, { emit }) {
    const ruleForm = ref();
    const form = ref({
      time_type: 1,
      time_arr: [{ time: null }],
      date_arr: [{ start: null, end: null }],
      week_arr: [],
      rule_mark_time: 1,
    });
    const submit = () => {
      ruleForm.value
        .validate()
        .then(async (res) => {
          console.log(res);
          var date_arr = [];
          console.log(form.value);
          if (form.value.time_arr.find((v) => !v.end)) {
            message.error("请输入完整时间");
            return;
          }
          console.log(0);

          if (
            form.value.time_type == 3 &&
            form.value.date_arr.find((v) => !v.time.length)
          ) {
            message.error("请输入完整时间");
            return;
          } else if (form.value.time_type == 3) {
            date_arr = form.value.date_arr.map((v) => {
              return {
                start: v.time[0],
                end: v.time[1],
              };
            });
          }
          console.log(date_arr);

          // if (form.value.date_arr.length) {
          //   date_arr = form.value.date_arr.map((element) => {
          //     return {
          //       start: element.time[0],
          //       end: element.time[1],
          //     };
          //   });
          // }
          console.log(222);
          emit("ployDone", {
            ...form.value,
            date_arr,
          });
        })
        .catch((error) => error);
    };
    const addTime = () => {
      form.value.time_arr.push({ time: null });
    };
    const delTime = (index) => {
      form.value.time_arr.splice(index, 1);
    };
    const changeTime = (e, index) => {
      if (e[1]) {
        form.value.time_arr[index] = [
          e[0].format("YYYY-MM-DD"),
          e[1].format("YYYY-MM-DD"),
        ];
      } else {
        form.value.time_arr[index] = [];
      }
    };
    const addDate = () => {
      form.value.date_arr.push({
        start: null,
        end: null,
      });
    };
    const delDate = (index) => {
      form.value.date_arr.splice(index, 1);
    };
    const changeDate = (e, index) => {
      if (
        moment(form.value.date_arr[index].start).unix(moment().format("X")) >
        moment(e).unix(moment().format("X"))
      ) {
        message.error("结束时间不能小于开始时间");
        form.value.date_arr[index].end = "";
        return;
      }
      // console.log(e.format('HH:mm:ss'))
      // form.value.date_arr[index].end=e.format('HH:mm:ss')
    };
    const renderDetail = (data, index) => {
      form.value = JSON.parse(JSON.stringify(data));
      console.log(form.value);
      form.value.date_arr = form.value.date_arr || [];
      form.value.time_arr = form.value.time_arr || [];
      form.value.index = index;
      if (form.value.date_arr.length) {
        form.value.date_arr = [];
        data.date_arr.forEach((element) => {
          form.value.date_arr.push({
            time: [
              moment(element['start'], "YYYY-MM-DD"),
              moment(element['end'], "YYYY-MM-DD"),
            ],
          });
        });
      }
    };
    // 禁用小时
    const disabledHours=(e,v)=>{
      let hours = []
      let time = v.start
      let timeArr = time.split(':')
      for (var i = 0; i < parseInt(timeArr[0]); i++) {
        hours.push(i)
      }
      return hours
    }
    const getDisabledMinutes =(selectedHour,v) =>{
      console.log(v)
      let time = v.start
      let timeArr = time.split(':')
      let minutes = []
      if (selectedHour == parseInt(timeArr[0])) {
        for(var i = 0; i < parseInt(timeArr[1]); i++) {
          minutes.push(i)
        }
      }
      return minutes
    }
   const getDisabledSeconds =(selectedHour, selectedMinute,v)=> {
      let time = v.start
      let timeArr = time.split(':')
      let second = []
      if (selectedHour == parseInt(timeArr[0]) && selectedMinute == parseInt(timeArr[1])) {
        for(var i = 0; i <= parseInt(timeArr[2]); i++) {
          second.push(i)
        }
      }
      return second
    }
    return {
      getDisabledMinutes,
      getDisabledSeconds,
      form,
      ruleForm,
      rules,
      submit,
      addTime,
      addDate,
      delDate,
      delTime,
      changeTime,
      changeDate,
      renderDetail,
      disabledHours,
      moment
    };
  },
};
</script>